import { Button, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import dayjs from "dayjs";
import { FaVideo } from "react-icons/fa6";
import { RiCalendarTodoFill, RiTimerLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openAddVoucherModel } from "../../../modules/admin-modules/models/Actions";
import { moreVideoViewsRequest } from "../../../modules/students-modules/videos/Actions";
import {
  countSeens,
  getVideoLockMessage,
  isClickSuspended,
  isDurationExceeded,
} from "../video/func";

const VideoCourse = ({ video, setSelectedData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { chapter } = useSelector((state) => state.studentChapters);

  const date1 = dayjs(video?.expiry_date);
  const diff = date1.diff(new Date(), "day");

  const lockMessage = getVideoLockMessage(video);
  const openVideo = () => {
    navigate(
      `/video/${video?.id}?chapter_name=${chapter?.name}&chapter_id=${chapter?.id}`
    );
  };

  return (
    <VStack
      w="100%"
      fontSize="14px"
      alignItems="flex-start"
      onClick={() => {
        if (isClickSuspended(video) || isDurationExceeded(video)) return;
        countSeens(dispatch, video);
        if (
          video?.max_allowed_views < video?.views_count?.views_count ||
          video?.suspended === 0 ||
          video?.user_video_suspended === 0
        ) {
          openVideo();
        }
      }}
    >
      <VStack
        w="100%"
        fontSize="14px"
        alignItems="flex-start"
        border="1px solid #eee"
        p={4}
        borderRadius={5}
        cursor="pointer"
        shadow="lg"
      >
        <HStack w="100%">
          <FaVideo size={18} />
          {/* title */}
          <Text fontSize="18px" fontWeight="500" textTransform="capitalize">
            {video?.title || video?.name}
          </Text>
        </HStack>
        <HStack spacing="8px">
          <Icon as={RiCalendarTodoFill} size={18} />
          <Text>{dayjs(video?.created_at).format("D , MMM ,YYYY")}</Text>
        </HStack>
        {diff && (
          <HStack>
            <Icon as={RiTimerLine} size={18} />
            <Text>{diff > 0 ? diff : 0} Days remaining</Text>
          </HStack>
        )}
                 {(isClickSuspended(video) ||
           isDurationExceeded(video) ||
           (video?.suspended === 1 && video?.user_video_suspended !== 0)) && (
           <>
             {lockMessage && (
               <Text textAlign="center" p={4} fontSize="20px">
                 {lockMessage}
               </Text>
             )}
             <HStack alignItems="center" gap={1} alignSelf="end">
               <Button
                 bg="main_1"
                 color="white"
                 onClick={(e) => {
                   console.log(video);
                   e.stopPropagation();
                   let formData = new FormData();
                   formData.append("video_id", video?.id);
                   dispatch(moreVideoViewsRequest(formData));
                 }}
               >
                 Request Voucher
               </Button>
               <Button
                 mt="0 !important"
                 border="1px solid"
                 color="main_1"
                 bg="main_1_light"
                 onClick={(e) => {
                   e.stopPropagation();
                   setSelectedData(video);
                   dispatch(openAddVoucherModel());
                 }}
               >
                 Add Voucher Code
               </Button>
             </HStack>
           </>
         )}
      </VStack>
    </VStack>
  );
};

export default VideoCourse;
